<template>
<div class="PrefabCreator_topMenu_kassa_holder">
  <div class="PrefabCreator_topMenu" @click.prevent="ToggleClass">
    <div class="position-relative stepsDropDown_prefabHolder" >
      <div class="currentMenu d-flex align-items-center gap-2">
        <span style="    min-width: max-content;"> {{CurrentCategory.title_swe}}</span><span><svg data-v-7ba5bd90="" width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-7ba5bd90="" d="M13.8399 4.52344L8.16215 9.63344L2.48438 4.52344" stroke="#6F6F6F" stroke-width="1.70333"></path></svg></span>
      </div>
      <ul class="stepsDropDown_prefab">
        <li v-for="cat in SubCategories" :key="cat.category_nr+'_prefab'" @click="Commit_current_view(cat)" class="">
          {{cat.title_swe}}
        </li>
      </ul>
    </div>
  </div>
  <div class="PrefabCreator_topMenu_kassa">
    <a id="top_menu_summary"    @click="activateTopMenu('ProductSummery')">
      <span><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.1" d="M7.67578 17.375C8.03781 17.3752 8.39215 17.2705 8.69601 17.0737C8.99987 16.8769 9.24025 16.5963 9.38813 16.2659C9.536 15.9354 9.58505 15.5692 9.52935 15.2115C9.47365 14.8538 9.31557 14.5198 9.07422 14.25H17.8242C18.0656 14.5198 18.2236 14.8538 18.2793 15.2115C18.3351 15.5692 18.286 15.9354 18.1381 16.2659C17.9902 16.5963 17.7499 16.8769 17.446 17.0737C17.1421 17.2705 16.7878 17.3752 16.4258 17.375H7.67578Z" fill="#061B3A"/>
<path d="M16.4258 14.25V5.50002C16.4268 5.2535 16.379 5.00922 16.2852 4.78126C16.1913 4.55331 16.0532 4.3462 15.8789 4.17189C15.7046 3.99757 15.4975 3.8595 15.2695 3.76564C15.0416 3.67178 14.7973 3.62398 14.5508 3.62502H3.92578" stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.92578 8.625H13.9258" stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.92578 11.125H13.9258" stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.52734 6.75095C2.32495 6.52434 2.18066 6.25195 2.10689 5.95721C2.03312 5.66247 2.03208 5.35421 2.10386 5.05898C2.17564 4.76375 2.31809 4.49039 2.51895 4.26242C2.71981 4.03445 2.97306 3.85871 3.2569 3.75032C3.54074 3.64193 3.84667 3.60414 4.14835 3.64021C4.45004 3.67628 4.73844 3.78512 4.98873 3.95736C5.23902 4.1296 5.44371 4.36009 5.58516 4.62899C5.72662 4.89788 5.80062 5.19712 5.80078 5.50095V15.501C5.80094 15.8048 5.87494 16.104 6.0164 16.3729C6.15786 16.6418 6.36254 16.8723 6.61283 17.0445C6.86312 17.2168 7.15152 17.3256 7.45321 17.3617C7.75489 17.3978 8.06082 17.36 8.34466 17.2516C8.6285 17.1432 8.88175 16.9675 9.08261 16.7395C9.28347 16.5115 9.42592 16.2382 9.4977 15.9429C9.56948 15.6477 9.56845 15.3394 9.49467 15.0447C9.4209 14.75 9.27661 14.4776 9.07422 14.251H17.8242C18.0656 14.5208 18.2236 14.8547 18.2794 15.2125C18.3351 15.5702 18.286 15.9364 18.1381 16.2668C17.9903 16.5973 17.7499 16.8779 17.446 17.0747C17.1422 17.2715 16.7878 17.3761 16.4258 17.376H7.67578" stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span>
      <span >{{$t('Summering')}}</span>
    </a>
  </div>
</div>

</template>
<script>

export default {
  name: "topMenu",
  components: {},
  computed: {
    SubCategories() {
      return this.$store.getters.SubCategories.filter(x => x.HideForCustomer !== true)
    },
    CurrentCategory() {
      return this.$store.state.CurrentCategory
    },

  },
  watch:{

  },
  methods: {
    activateTopMenu(e, a) {
      if (this.$store.state.activeTab === e) {
        this.$store.commit('commit_activeTab', 'ProductChooser')
      } else {
        this.$store.commit('commit_activeTab', e)
      }

    },
    getActiveMenu(e) {
      if (this.$store.state.view === e) {
        return 'current'
      }
    },
    ToggleClass() {
      document.querySelector('.stepsDropDown_prefabHolder').classList.toggle('hover')
      // Add any other hover-related classes here);
    },
    Commit_current_view(e) {
      this.$store.commit('commit_activeTab', 'ProductChooser')
      this.$store.commit('commit_current_view', e.category_nr)
      this.$store.commit('commit_current_category', e)

      let section = document.getElementById("anchor_" + e.category_nr)
      if (section) {
        const sectionTop = section.offsetTop - 100;
        document.getElementById('PrefabCreator_SelectorsBtns').scrollTo({
          top: sectionTop,
        });
        this.toggleClass()
      }

    },
    Commit_current_view_(e, v) {
      this.$store.commit('commit_current_view', e)
      let section = document.getElementById("anchor_kassa")
      const sectionTop = section.offsetTop;
      document.getElementById('PrefabCreator_SelectorsBtns').scrollTo({
        top: sectionTop,
      });

    }
  }
}
</script>


<style lang="scss" scoped>
.PrefabCreator_topMenu{
  .currentMenu{
    padding-bottom: 10px;
    font-weight: 500;
    cursor: pointer;
    &:hover{
      opacity: 0.8;
    }
  }
}

.stepsDropDown_prefabHolder{
  margin-top: 10px;
  font-size: 14px;
  &.hover{
    ul.stepsDropDown_prefab{
      display: flex!important;
    }
  }
  ul.stepsDropDown_prefab{
    display: none;
    flex-direction: column;
    min-width: 300px;
    overflow: auto;
    max-height: 300px;
    border-radius: 6px;
    list-style: none;
    // display: none;
    position: absolute;
    z-index: 99;
    background-color: white;
    padding: 0;
    transition: all 0.2s ease-in-out;
    right: auto !important;
    background: var(--gray-white, #fff);
    box-shadow: 0 8px 15px 1px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.05);
    &::-webkit-scrollbar{
      display: none;
    }
    li{
      min-width: max-content;
      color: #000 !important;
      width: 100% !important;
      display: block !important;
      padding: 10px 2rem !important;
      border-bottom: 1px solid #e8e8e8 !important;
      border-radius: unset;
      cursor: pointer;
      &:hover{
        background: #edf4f2;
      }
    }
  }
}
.PrefabCreator_topMenu_kassa {


 #top_menu_summary {

   color: #000;
   text-decoration: unset;
   background: transparent; /* Set transparent background by default */
   border-radius: 30px;
   padding: 6px 14px;
   font-size: 14px;
   background: var(--gray-03, #F3F3F3);
   font-weight: 500;
   display: flex;
   align-items: center;
   gap: 6px;
   cursor: pointer;
   &:hover{
     background-color: rgba(243, 243, 243, 0.8);
 }

  }
}
.PrefabCreator_topMenu_kassa_holder{
  display: flex;
  align-items: center;
  gap: 20px;
}
</style>
